import React from "react";
import { useNavigate } from "react-router-dom";

export default function SidebarWithRouter() {
  const navigate = useNavigate();

  const handleNavClick = (hash) => {
    const fullUrl = `/${hash}`;
    if (window.location.pathname !== "/") {
      window.location.href = fullUrl; // 🔁 full reload
    } else {
      // Already on homepage
      setTimeout(() => {
        window.location.hash = hash;
      }, 100);
    }
  };

  return (
    <div>
      <div>
        <nav
          href="#navbar"
          className="js-colorlib-nav-toggle colorlib-nav-toggle"
          data-toggle="collapse"
          data-target="#navbar"
          aria-expanded="false"
          aria-controls="navbar"
        >
          <i />
        </nav>
        <aside id="colorlib-aside" className="border js-fullheight">
          <div className="text-center">
            <div
              className="author-img"
              style={{ backgroundImage: "url(images/about.jpg)" }}
            />
            <h1 id="colorlib-logo">
              <button
                onClick={() => handleNavClick("#colorlib-hero")}
                className="nav-btn"
              >
                Abhijeet Verma
              </button>
            </h1>
            <h4 id="colorlib-fetaure">BIM Engineer</h4>
            <span className="email">
              <i className="icon-mail"></i> vermaabhijeet684@gmail.com
            </span>
            <br />
          </div>

          <nav id="colorlib-main-menu" role="navigation" className="navbar">
            <div id="navbar" className="collapse">
              <ul>
                {[
                  ["Introduction", "#colorlib-hero"],
                  ["About", "#about"],
                  ["Broshure", "#broshure"],
                  ["Services", "#services"],
                  ["Projects", "#projects"],
                  ["Skills", "#skills"],
                  ["Gallery", "#gallery"],
                  ["Certifications", "#certifications"],
                  ["Reviews", "#reviews"],
                  ["Contact", "#contact"],
                ].map(([label, hash]) => (
                  <li key={label}>
                    <button
                      className="nav-btn"
                      onClick={() => handleNavClick(hash)}
                    >
                      {label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          </nav>

          <nav id="colorlib-main-menu">
            <ul>
              <li>
                <a
                  href="https://www.linkedin.com/in/abhijeetverma684/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={process.env.PUBLIC_URL + "/images/linkedin.svg"}
                    alt="Linkedin"
                  />
                </a>
              </li>
              <li>
                <a
                  href="https://www.fiverr.com/verma_abhijeet"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={process.env.PUBLIC_URL + "/images/fiverr.svg"}
                    alt="Fiverr"
                  />
                </a>
              </li>
              <li>
                <a
                  href="https://www.upwork.com/freelancers/~013c008d066058179f"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={process.env.PUBLIC_URL + "/images/upwork.svg"}
                    alt="UpWork"
                  />
                </a>
              </li>
              <li>
                <a
                  href="https://www.picktime.com/89a0b775-d985-4dd5-815a-ac11e75bf05d"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={process.env.PUBLIC_URL + "/images/picktime.jpg"}
                    alt="Book me"
                  />
                </a>
              </li>
            </ul>
          </nav>

          <div className="colorlib-footer">
            <p>
              <small>Thank you for visiting my profile. Let's Connect.</small>
            </p>
            <p>
              <small>
                Website Inspiration : Colorlib{" "}
                <i className="icon-heart" aria-hidden="true" /> <br />
              </small>
            </p>
          </div>
        </aside>
      </div>
    </div>
  );
}
